var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-router',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Patreon'),expression:"'Patreon'"}],staticClass:"inbox",attrs:{"to":{name: (_vm.$loggedin) ? 'SessionPatreon' : 'CommunityPatreon'}}},[_c('div',{staticClass:"inbox-icon"},[_c('i',{staticClass:"fa-brands fa-patreon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }